<template lang="pug">
  .room.anchor-room
    SwitchStatus.divice-block-thin(title="浦口侧锚室除湿机组运行状态" :series="SwitchStatusData")
    RunningTime.divice-block-thin(title="浦口侧锚室除湿机组累计运行时间" :series="RunningTimeData")
    .divice-block(:class="warningFlag1")
      .divice-block-1
        DoubleGraph(:opts="humidity1" :series="humidity1Data")
      .divice-block-2
        SinglePieHistogramWrap(:opts="SinglePieHistogramWrapOpts1" :series="SinglePieHistogramWrapData1" )
    .divice-block(:class="warningFlag2")
      .divice-block-1
        DoubleGraph(:opts="humidity2" :series="humidity2Data")
      .divice-block-2
        SinglePieHistogramWrap(:opts="SinglePieHistogramWrapOpts2" :series="SinglePieHistogramWrapData2" )
    .divice-block(:class="warningFlag3")
      .divice-block-1
        DoubleGraph(:opts="humidity3" :series="humidity3Data")
      .divice-block-2
        SinglePieHistogramWrap(:opts="SinglePieHistogramWrapOpts3" :series="SinglePieHistogramWrapData3" )
    .divice-block(:class="warningFlag4")
      .divice-block-1
        DoubleGraph(:opts="humidity4" :series="humidity4Data")
      .divice-block-2
        SinglePieHistogramWrap(:opts="SinglePieHistogramWrapOpts4" :series="SinglePieHistogramWrapData4" )
    RefreshBlock(@refreshData="refreshData")
</template>
<script>
export default {
  name: 'anchorRoomPK',
  data () {
    return {
      timer: null,
      warningFlag1: '',
      warningFlag2: '',
      warningFlag3: '',
      warningFlag4: '',
      humidity1: {
        title: '浦口侧锚室温湿度1',
        legend1: '湿度',
        legend2: '温度'
      },
      SwitchStatusData: null,
      RunningTimeData: null,
      humidity1Data: null,
      humidity2: {
        title: '浦口侧锚室温湿度2',
        legend1: '湿度',
        legend2: '温度'
      },
      humidity2Data: null,
      humidity3: {
        title: '浦口侧锚室温湿度3',
        legend1: '湿度',
        legend2: '温度'
      },
      humidity3Data: null,
      humidity4: {
        title: '浦口侧锚室温湿度4',
        legend1: '湿度',
        legend2: '温度'
      },
      humidity4Data: null,
      SinglePieHistogramWrapData1: null,
      SinglePieHistogramWrapOpts1: {
        title: '当前温湿度',
        histogramName1: 'T',
        center1: ['50%', '60%'],
        radius1: ['46%', '70%'],
        pieName1: 'RH',
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: '°C'
      },
      SinglePieHistogramWrapData2: null,
      SinglePieHistogramWrapOpts2: {
        title: '当前温湿度',
        histogramName1: 'T',
        center1: ['50%', '60%'],
        radius1: ['46%', '70%'],
        pieName1: 'RH',
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: '°C'
      },
      SinglePieHistogramWrapData3: null,
      SinglePieHistogramWrapOpts3: {
        title: '当前温湿度',
        histogramName1: 'T',
        center1: ['50%', '60%'],
        radius1: ['46%', '70%'],
        pieName1: 'RH',
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: '°C'
      },
      SinglePieHistogramWrapData4: null,
      SinglePieHistogramWrapOpts4: {
        title: '当前温湿度',
        histogramName1: 'T',
        center1: ['50%', '60%'],
        radius1: ['46%', '70%'],
        pieName1: 'RH',
        max: 50,
        pieMax: 100,
        toprichFontSize: 18,
        topFontSize: 20,
        sign: '°C'
      }
    }
  },
  mounted () {
    this.getDatas()
    this.getLineDatas()
    this.timer = setInterval(() => {
      this.getDatas()
      this.getLineDatas()
    }, this.REFRESH_SECOND)
  },
  beforeDestroy () {
    clearInterval(this.timer)
  },
  methods: {
    refreshData () {
      this.getDatas()
      this.getLineDatas()
      clearInterval(this.timer)
      this.timer = setInterval(() => {
        this.getDatas()
        this.getLineDatas()
      }, this.REFRESH_SECOND)
    },
    getDatas () {
      this.$http.get('/deviceData/Station?stationId=1dd09a7b-f0be-4838-973e-b72b03325167').then(res => {
        this.$store.commit('setLastRefreshTime')
        const __data = res.data
        this.setPieHisData(__data, 'SinglePieHistogramWrapData1', 'c20c6353-3a32-4793-8456-1b65b239e72a', 'bc87a161-a5f2-4a67-8e13-17c4cb63dc7d', 'warningFlag1')
        this.setPieHisData(__data, 'SinglePieHistogramWrapData2', 'afede043-98f0-4345-a645-93be78b87812', 'f45a7615-14d6-4ffc-9bb9-10403eef761b', 'warningFlag2')
        this.setPieHisData(__data, 'SinglePieHistogramWrapData3', '01a7ac8e-0857-4817-906f-66719fc148fa', '7bc31a5f-f6d7-4c3f-b7c5-cf9fe6f01291', 'warningFlag3')
        this.setPieHisData(__data, 'SinglePieHistogramWrapData4', 'b07544de-355d-425f-aad4-65c935eea931', '33019f30-a330-4066-95ee-263e0ac07bd2', 'warningFlag4')
        this.SwitchStatusData = {
          data: __data['769205af-c48d-4a46-bc8a-b74393d366bc'].value,
          isError: __data['769205af-c48d-4a46-bc8a-b74393d366bc'].errorLevel
        }
        this.RunningTimeData = __data['c787f0fc-c714-421e-ac35-0660ae975ca3'].value
      })
    },
    setPieHisData (datas, dataName, data1Id, data2Id, warnName) {
      this[dataName] = {
        data1: datas[data1Id].value,
        data2: datas[data2Id].value
      }
      if (datas[data2Id].errorLevel !== 'Normal' && this[warnName] !== 'Error') {
        this[warnName] = datas[data2Id].errorLevel
      }
      if (datas[data1Id].errorLevel !== 'Normal' && this[warnName] !== 'Error') {
        this[warnName] = datas[data1Id].errorLevel
      }
    },
    GetDeviceData (id) {
      return this.$http.get('/statistics/DeviceData?deviceId=' + id + '&interval=BY_HOUR&insertBlankData=true')
    },
    getLineDatas () {
      const that = this
      this.$http.all([this.GetDeviceData('c20c6353-3a32-4793-8456-1b65b239e72a'), this.GetDeviceData('bc87a161-a5f2-4a67-8e13-17c4cb63dc7d')])
        .then(
          that.$http.spread(function (res1, res2) {
            that.dealData(res1, res2, 'humidity1Data', that, 'warningFlag1')
          })
        )
      this.$http.all([this.GetDeviceData('afede043-98f0-4345-a645-93be78b87812'), this.GetDeviceData('f45a7615-14d6-4ffc-9bb9-10403eef761b')])
        .then(
          that.$http.spread(function (res1, res2) {
            that.dealData(res1, res2, 'humidity2Data', that, 'warningFlag2')
          })
        )
      this.$http.all([this.GetDeviceData('01a7ac8e-0857-4817-906f-66719fc148fa'), this.GetDeviceData('7bc31a5f-f6d7-4c3f-b7c5-cf9fe6f01291')])
        .then(
          that.$http.spread(function (res1, res2) {
            that.dealData(res1, res2, 'humidity3Data', that, 'warningFlag3')
          })
        )
      this.$http.all([this.GetDeviceData('b07544de-355d-425f-aad4-65c935eea931'), this.GetDeviceData('33019f30-a330-4066-95ee-263e0ac07bd2')])
        .then(
          that.$http.spread(function (res1, res2) {
            that.dealData(res1, res2, 'humidity4Data', that, 'warningFlag4')
          })
        )
    },
    dealData (res1, res2, name, that, warnName) {
      const __data = {}
      const __data1 = {}
      const _list1 = res1.data.dataList // .splice(-10)
      _list1.forEach((el, index) => {
        __data[el.dataDate] = el.value
      })
      const _list2 = res2.data.dataList // .splice(-10)
      _list2.forEach((el, index) => {
        __data1[el.dataDate] = el.value
      })
      that[name] = {
        data1: __data,
        data2: __data1
      }
      if (res1.data.errorLevel !== 'Normal' && that[warnName] !== 'Error') {
        that[warnName] = res1.data.errorLevel
      }
      if (res2.data.errorLevel !== 'Normal' && that[warnName] !== 'Error') {
        that[warnName] = res2.data.errorLevel
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.anchor-room {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: stretch;
  align-content: stretch;
  padding-top: 10px;
  .divice-block {
    width: calc(50% - 10px);
    height: calc(50% - 40px);
  }
  .divice-block-thin {
    height: 42px;
    width: calc(50% - 10px);
    box-sizing: border-box;
  }
  .divice-block {
    display: flex;
    justify-content: space-between;
    align-items: stretch;
  }
  .divice-block-1 {
    width: 75%;
    height: 100%;
  }
  .divice-block-2 {
    width: 24%;
    height: 96%;
  }
}
</style>
